enum RATING_REPORTS {
	BENEFIT_DEMAND = '/api/score-reports/benefits/demand',
	BENEFIT_DEMAND_EXPORT = '/api/score-reports/benefits/demand/export',
	BENEFITS_SUMMARY = '/api/score-reports/benefits/summary',
	STUDENTS_ACTIVITY = '/api/score-reports/students/activity',
	STUDENT_HISTORY = '/api/score-reports/students/'
}

export default RATING_REPORTS;
